import {fork, put, race, take} from 'redux-saga/effects';

let sagaErrorCount = 0;
const maxSagaErrors = 10;

export function* forkSafely(saga, ...args) {
    try {
        yield fork(saga, ...args);
    } catch (e) {
        ++sagaErrorCount;
        if (__DEV__) {
            console.error(e);
        }
        // restart
        if (sagaErrorCount <= maxSagaErrors) {
            yield forkSafely(...arguments);
        } else {
            console.log('Preventing saga restart due to too many saga errors', sagaErrorCount);
        }
    }
}

export function* doApiCall(apiCall, data, context, success, error) {
    console.log('calling api');
    const apiAction = apiCall(data, context);
    console.log(apiAction);
    yield put(apiAction);
    const result = yield race({
        success: take(success),
        error: take(error),
    });
    if (result.error) {
        throw new Error(result.error.payload?.error || result.error.type);
    }
    return result.success;
}